import React from "react";
import SeriesEditPage from "../catalogue/SeriesEditPage";
import {
  deletePodcastSeason,
  getPodcast,
  getPodcastSeasonList,
  updatePodcast,
} from "../../../services/podcasts";
import { getPodcastGC } from "../../../store/actions/uploadMediaAction";

const UpdatePodcast = () => (
  <SeriesEditPage
    idParam="podcast_id"
    load={getPodcast}
    storeKey="generalContentObjPodcast"
    setInfo={getPodcastGC}
    pagePath={(id) => `/dashboard/update-podcast/${id}`}
    category="podcast"
    genreType="podcast"
    tagSuffix="-podcast"
    update={updatePodcast}
    loadSeasons={getPodcastSeasonList}
    deleteSeason={deletePodcastSeason}
    crewUrl="podcast"
    infoPath={(id) => `/dashboard/podcast-info/${id}`}
    episodesPath={(id) => `/dashboard/podcast-episode-list/${id}`}
    listPath="/dashboard/podcast-list"
    texts={{
      title: "Edit Podcast",
      updated: "Podcast Info Updated Successfully!",
      seasonError: "Error In Adding Season to Podcast",
    }}
  />
);

export default React.memo(UpdatePodcast);
